export default __webpack_public_path__ + "static/media/services2.b509dc5e.jpg";